
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

common.View.create('canvas.blocks.custom.header.Block', {

    onDOMLoad() {
        this.initSlider();
    },

    initSlider() {
        let swiperElement = this.element.find('.swiper-container');
        let swiperManualDisabled = false;
        
        // Check if navigation elements exist
        const nextEl = this.element.find('.swiper-button-next').get(0);
        const prevEl = this.element.find('.swiper-button-prev').get(0);
        const paginationEl = this.element.find('.swiper-pagination').get(0);
        
        // Read data attributes for edit mode configuration
        const swiperEl = swiperElement.get(0);
        const allowTouchMove = swiperEl.dataset.swiperAllowTouchMove !== 'false';
        const simulateTouch = swiperEl.dataset.swiperSimulateTouch !== 'false';
        const autoplayEnabled = swiperEl.dataset.swiperAutoplay !== 'false';
        
        const swiperConfig = {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            speed: 1500,
            allowTouchMove: allowTouchMove,
            simulateTouch: simulateTouch,
        };

        // Only add autoplay if enabled (not in edit mode)
        if (autoplayEnabled) {
            swiperConfig.autoplay = {
                delay: 5000,
                disableOnInteraction: false,
            };
        }

        // Add navigation if elements exist
        if (nextEl && prevEl) {
            swiperConfig.navigation = {
                nextEl: nextEl,
                prevEl: prevEl,
            };
        }

        // Add pagination if element exists
        if (paginationEl) {
            swiperConfig.pagination = {
                el: paginationEl,
                clickable: true,
            };
        }
        
        const swiper = new Swiper(swiperElement.get(0), swiperConfig);

        // Only set up autoplay toggle if autoplay is enabled
        if (autoplayEnabled) {
            const autoplayToggleButton = this.element.find('#autoplayToggle');
            autoplayToggleButton.on('click', () => {
                if (!swiperManualDisabled) {
                    swiper.autoplay.stop();
                    autoplayToggleButton.html('<i class="fas fa-play"></i>'); // change to play icon
                    swiperManualDisabled = true;
                } else {
                    swiper.autoplay.start();
                    autoplayToggleButton.html('<i class="fas fa-pause"></i>'); // change to pause icon
                    swiperManualDisabled = false;
                }
            });
        }

        // Optional: Pause autoplay on hover and focus for accessibility (only if autoplay is enabled)
        if (autoplayEnabled) {
            swiperElement
                .on('mouseenter', function() {
                    if (!swiperManualDisabled) {
                        swiper.autoplay.stop();
                    }
                })
                .on('mouseleave', function() {
                    if (!swiperManualDisabled) {
                        swiper.autoplay.start();
                    }
                })
                .on('focusin', function() {
                    if (!swiperManualDisabled) {
                        swiper.autoplay.stop();
                    }
                })
                .on('focusout', function() {
                    if (!swiperManualDisabled) {
                        swiper.autoplay.start();
                    }
                });
        }
    }
});